import desktopDivider from "./images/pattern-divider-desktop.svg";
import mobileDivider from "./images/pattern-divider-mobile.svg";
import dice from "./images/icon-dice.svg";
import { useState } from "react";

export default function App() {
  return <Advice />;
}

function Advice() {
  const [advice, setAdvice] = useState(null);
  const [id, setId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, SetError] = useState(null);

  async function handleGetAdvice() {
    setIsLoading(true);
    SetError(null);
    try {
      const res = await fetch(`https://api.adviceslip.com/advice`);

      if (!res.ok) throw new Error("Network response was not ok");

      const data = await res.json();

      setAdvice(data.slip.advice);
      setId(data.slip.id);
    } catch (err) {
      SetError("Failed to fetch advice. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="card">
      {/* Quote Number */}
      <p className="card__number">
        {isLoading && "Loading..."}
        {!isLoading && error && error}
        {!isLoading && !error && advice && `Advice #${id}`}
        {!isLoading && !error && !advice && `Advice #117`}
      </p>

      {/* Quote */}
      <h1 className="card__quote">
        {isLoading && "Loading..."}
        {!isLoading && error && error}
        {!isLoading && !error && advice && `"${advice}"`}
        {!isLoading &&
          !error &&
          !advice &&
          `"It is easy to sit up and take notice, what's difficult is getting up and taking action."`}
      </h1>

      {/* Picture tag for responsive image */}
      <picture className="card__divider">
        <source media="(min-width: 500px)" srcSet={desktopDivider} />
        <img src={mobileDivider} alt="divider" />
      </picture>

      {/* Dice image */}
      <span className="card__dice-box" onClick={handleGetAdvice}>
        <img src={dice} className="card__dice" alt="dice" />
      </span>
    </div>
  );
}
